function warn(s) {
  console.warn('[react-ga]', s);
}

module.exports = warn;



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-ga/src/utils/console/warn.js
 ** module id = 266
 ** module chunks = 0
 **/